import React from 'react'

const IconGoogleDocs = ({fillColor, style, ...props}) => {
  return (
   <svg {...props} xmlns="http://www.w3.org/2000/svg" className={'icon ' + fillColor} style={style} viewBox="0 0 36 36">
      <path d="M9 3H22L29 10V32A3 3 0 0 1 26 35H9A3 3 0 0 1 6 32V6A3 3 0 0 1 9 3Z" fill="#4285f4"/>
      <path d="M22 3V10H29Z" fill="#a1c2fa"/>
      <rect x="10" y="16" width="15" height="2.2" rx="1.1" fill="#ffffff"/>
      <rect x="10" y="20.4" width="15" height="2.2" rx="1.1" fill="#ffffff"/>
      <rect x="10" y="24.8" width="10" height="2.2" rx="1.1" fill="#ffffff"/>
   </svg>
  )
}
export default IconGoogleDocs
